import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { normalizePhoneNumber } from '@chegg-ui/utils';
import { InputWrapper } from '@chegg-ui/input-wrapper';
import { getThemeConfig } from '../externals';
import { BasicStyledInput } from '../styles';
var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var dataTest = _ref['data-test'],
      adjustToBackgroundColor = _ref.adjustToBackgroundColor,
      className = _ref.className,
      disabled = _ref.disabled,
      errorCta = _ref.errorCta,
      errorText = _ref.errorText,
      helperText = _ref.helperText,
      inputId = _ref.inputId,
      labelText = _ref.labelText,
      leadingIcon = _ref.leadingIcon,
      leadingIconClickable = _ref.leadingIconClickable,
      givenOnChange = _ref.onChange,
      theme = _ref.theme,
      trailingIcon = _ref.trailingIcon,
      trailingIconClickable = _ref.trailingIconClickable,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      visuallyHideLabel = _ref.visuallyHideLabel,
      width = _ref.width,
      remainingInputProps = _objectWithoutProperties(_ref, ["data-test", "adjustToBackgroundColor", "className", "disabled", "errorCta", "errorText", "helperText", "inputId", "labelText", "leadingIcon", "leadingIconClickable", "onChange", "theme", "trailingIcon", "trailingIconClickable", "type", "visuallyHideLabel", "width"]);

  var componentTheme = useComponentTheme({
    name: 'Input',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(InputWrapper, {
    adjustToBackgroundColor: adjustToBackgroundColor,
    className: className,
    "data-test": dataTest,
    disabled: disabled,
    errorCta: errorCta,
    errorText: errorText,
    leadingIcon: leadingIcon,
    leadingIconClickable: leadingIconClickable,
    helperText: helperText,
    inputId: inputId,
    labelText: labelText,
    trailingIcon: trailingIcon,
    trailingIconClickable: trailingIconClickable,
    visuallyHideLabel: visuallyHideLabel,
    width: width
  }, /*#__PURE__*/React.createElement(BasicStyledInput, _extends({}, remainingInputProps, {
    customTheme: componentTheme,
    "data-test": dataTest || inputId,
    disabled: disabled,
    hasLeadingIcon: Boolean(leadingIcon),
    hasTrailingIcon: Boolean(trailingIcon),
    id: inputId // TODO: this formatting is not very fully fleshed-out
    ,
    onChange: function onChange(e) {
      givenOnChange(type !== 'tel' ? e.target.value : normalizePhoneNumber(e.target.value));
    },
    ref: ref,
    type: type
  })));
});
Input.displayName = 'Input';
export default Input;